<template>
    <b-card bg-variant="danger" text-variant="white">
        <b-card-body>
            <b-row>
                <b-col cols="12" lg="6" class="avatar">
                    <img :src="visitor.photo" v-if="!!visitor.photo" alt="">
                    <i class="fa fa-exclamation-triangle fa-5x" v-else aria-hidden="true"></i>
                </b-col>
                <b-col cols="12" lg="6">
                    <b-row>
                        <b-col cols="12"><span class="font-weight-bold">Documento: </span>{{ visitor.document }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><span class="font-weight-bold">Nombre: </span>{{ visitor.name }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><span class="font-weight-bold">instrucciones:</span></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">{{ visitor.instructions }}</b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
export default {
    name: 'restricted_visitor_card',
    props: ['visitor']
}
</script>
<style scoped>
.avatar img {
    height: 200px;
    border-radius: 8px;
    border: 2px solid #C7CED5;
    padding: 3px;
    margin-bottom: 10px;
    text-align: center;
}
</style>